import i18n from '@/utils/i18n'

export const BET_HISTORY_CATEGORY_ALL = 7
export const BET_HISTORY_PAGE_SIZE = 20

export function buildBetHistoryDateRange (days = 7) {
  const end = new Date()
  end.setHours(23, 59, 59, 999)
  const start = new Date()
  start.setDate(start.getDate() - Math.max(0, days - 1))
  start.setHours(0, 0, 0, 0)
  return { start, end }
}

export function toBetHistoryApiDate (value) {
  const date = value instanceof Date ? value : new Date(value)
  if (Number.isNaN(date.getTime())) return new Date().toISOString()
  return date.toISOString()
}

export function formatDateInputValue (date) {
  const d = date instanceof Date ? date : new Date(date)
  if (Number.isNaN(d.getTime())) return ''
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${y}-${m}-${day}`
}

export function parseDateInputValue (value, endOfDay = false) {
  if (!value) return null
  const parts = String(value).split('-').map(Number)
  if (parts.length !== 3) return null
  const date = new Date(parts[0], parts[1] - 1, parts[2])
  if (Number.isNaN(date.getTime())) return null
  if (endOfDay) {
    date.setHours(23, 59, 59, 999)
  } else {
    date.setHours(0, 0, 0, 0)
  }
  return date
}

export function normalizeBetHistoryList (payload) {
  if (!payload) return []
  const list = Array.isArray(payload.list) ? payload.list : []
  return list.filter(item => item && !isSummaryRow(item))
}

export function isSummaryRow (item) {
  if (!item) return true
  const reg = String(item.regdate || '').trim()
  return reg === '합계' || reg === 'total' || reg.toLowerCase() === 'total'
}

export function betHistoryCategoryLabel (category) {
  const value = Number(category)
  if (value === 1) return i18n.t('betting.categorySlot')
  if (value === 2) return i18n.t('betting.categoryLive')
  if (value === 3) return i18n.t('betting.categoryFishing')
  if (value === 4) return i18n.t('betting.categoryMini')
  if (value === 5) return i18n.t('betting.categorySports')
  if (value === 7) return i18n.t('betting.categoryAll')
  return i18n.t('betting.categoryOther')
}
